import {RuleTriggersTypesEnum} from '../../../rules/ruleTriggerModel';
import {GetColumnValue} from './getColumnValue';
import {
  baseFactoryMethods,
  CommentResult,
  ConversationResult,
  DataTableResult,
  MessageResult,
  ResultType,
  ResultTypesEnum,
  TagResult,
  TeammateResult,
  TopicResult,
  TransformerIdsEnum,
} from './internal';

export const activityType: ResultType = {
  name: ResultTypesEnum.ACTIVITY,
  properties: {
    conversation: ConversationResult,
    data_table: DataTableResult,
    message: MessageResult,
    comment: CommentResult,
    added_tag: TagResult,
    removed_tag: TagResult,
    added_topic: TopicResult,
    removed_topic: TopicResult,
    previous_assignee: TeammateResult,
  },
  methods: {
    ...baseFactoryMethods,
    [TransformerIdsEnum.GET_COLUMN_VALUE]: new GetColumnValue(),
  },
};

export const activityTriggerProperties: Partial<Record<RuleTriggersTypesEnum, string[]>> = {
  [RuleTriggersTypesEnum.TAG]: ['added_tag'],
  [RuleTriggersTypesEnum.UNTAG]: ['removed_tag'],
  [RuleTriggersTypesEnum.TOPIC_ADDED]: ['added_topic'],
  [RuleTriggersTypesEnum.TOPIC_REMOVED]: ['removed_topic'],
  [RuleTriggersTypesEnum.ASSIGN]: ['previous_assignee'],
  [RuleTriggersTypesEnum.UNASSIGN]: ['previous_assignee'],
};
